<main 
  class="product-page-container" 
  itemscope 
  itemtype="https://schema.org/Product"
>
  <!-- BREADCRUMB / NAVEGACIÓN SECUNDARIA AEO OPTIMIZADA -->
  <nav 
    class="breadcrumb-nav" 
    aria-label="Navegación de ruta" 
    itemscope 
    itemtype="https://schema.org/BreadcrumbList"
  >
    <div class="container">
      <ol class="breadcrumb-list" style="list-style: none; padding: 0; margin: 0; display: flex; gap: 0.5rem; align-items: center;">
        <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a routerLink="/espiritus" itemprop="item" class="back-link" title="Volver a la Colección de Espíritus">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span itemprop="name">Volver a Colección de Espíritus</span>
          </a>
          <meta itemprop="position" content="1" />
        </li>
      </ol>
    </div>
  </nav>

  <!-- METADATOS INVISIBLES DE PRODUCTO PARA AEO Y SEARCH ENGINE OVERVIEWS -->
  <meta itemprop="name" [content]="product()?.name || 'Whisky Real Audiencia'" />
  <meta itemprop="description" [content]="getFormattedSemanticDescription()" />
  <meta itemprop="url" content="https://estancosdc.com/espiritus/whisky-real-audiencia" />
  
  <div itemprop="brand" itemscope itemtype="https://schema.org/Brand" style="display:none;">
    <meta itemprop="name" content="Estancos Distilling Co." />
  </div>

  <!-- CALIFICACIÓN AGREGADA (AGGREGATE RATING) SCHEMA.ORG PARA GOOGLE RICH RESULTS -->
  @if (reviewsCount() > 0) {
  <div itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating" style="display:none;">
    <meta itemprop="ratingValue" [content]="ratingValue()" />
    <meta itemprop="reviewCount" [content]="reviewsCount()" />
    <meta itemprop="bestRating" content="5" />
    <meta itemprop="worstRating" content="1" />
  </div>

  <!-- OPINIONES INDIVIDUALES (REVIEWS) PARA SCHEMA.ORG -->
  @for (rev of topReviews(); track rev.id) {
  <div itemprop="review" itemscope itemtype="https://schema.org/Review" style="display:none;">
    <div itemprop="author" itemscope itemtype="https://schema.org/Person">
      <meta itemprop="name" [content]="rev.customer_name" />
    </div>
    <div itemprop="reviewRating" itemscope itemtype="https://schema.org/Rating">
      <meta itemprop="ratingValue" [content]="rev.rating" />
      <meta itemprop="bestRating" content="5" />
      <meta itemprop="worstRating" content="1" />
    </div>
    <meta itemprop="reviewBody" [content]="rev.comment" />
    <meta itemprop="datePublished" [content]="rev.created_at" />
  </div>
  }
  }

  @if (product()) {
    <div itemprop="offers" itemscope itemtype="https://schema.org/Offer" style="display:none;">
      <meta itemprop="price" [content]="product()?.discount_price || product()?.price" />
      <meta itemprop="priceCurrency" content="USD" />
      <meta itemprop="availability" content="https://schema.org/InStock" />
      <meta itemprop="itemCondition" content="https://schema.org/NewCondition" />
      <meta itemprop="seller" content="Estancos Distilling Co." />

      <!-- POLÍTICA DE ENVÍOS (SHIPPING DETAILS - FICHA COMERCIANTE GOOGLE) -->
      <div itemprop="shippingDetails" itemscope itemtype="https://schema.org/OfferShippingDetails">
        <div itemprop="shippingRate" itemscope itemtype="https://schema.org/MonetaryAmount">
          <meta itemprop="value" content="5.00" />
          <meta itemprop="currency" content="USD" />
        </div>
        <div itemprop="shippingDestination" itemscope itemtype="https://schema.org/DefinedRegion">
          <meta itemprop="addressCountry" content="EC" />
        </div>
        <div itemprop="deliveryTime" itemscope itemtype="https://schema.org/ShippingDeliveryTime">
          <div itemprop="handlingTime" itemscope itemtype="https://schema.org/QuantitativeValue">
            <meta itemprop="minValue" content="1" />
            <meta itemprop="maxValue" content="5" />
            <meta itemprop="unitCode" content="d" />
          </div>
          <div itemprop="transitTime" itemscope itemtype="https://schema.org/QuantitativeValue">
            <meta itemprop="minValue" content="1" />
            <meta itemprop="maxValue" content="4" />
            <meta itemprop="unitCode" content="d" />
          </div>
        </div>
      </div>

      <!-- POLÍTICA DE DEVOLUCIONES (MERCHANT RETURN POLICY - FICHA COMERCIANTE GOOGLE) -->
      <div itemprop="hasMerchantReturnPolicy" itemscope itemtype="https://schema.org/MerchantReturnPolicy">
        <meta itemprop="applicableCountry" content="EC" />
        <meta itemprop="returnPolicyCategory" content="https://schema.org/MerchantReturnFiniteReturnWindow" />
        <meta itemprop="merchantReturnDays" content="15" />
        <meta itemprop="returnMethod" content="https://schema.org/ReturnByMail" />
        <meta itemprop="returnFees" content="https://schema.org/FreeReturn" />
      </div>
    </div>
  }

  @if (isLoading()) {
    <div class="loader-container" role="status" aria-live="polite">
      <div class="spinner" aria-hidden="true"></div>
      <div class="loader-text">Cargando Whisky Real Audiencia...</div>
    </div>
  } @else if (product()) {
    <!-- SECCIÓN HERO DE PRODUCTO DETALLADA -->
    <section class="product-hero-section" aria-labelledby="product-title-heading">
      <div class="container product-grid">

        <!-- COLUMNA IZQUIERDA: IMAGEN Y BADGES -->
        <div class="product-media-col">
          <div class="media-frame">
            <span class="badge-tag">Selección Reserva Andina</span>
            <img
              [src]="getOptimizedImageUrl(product()?.image_url, 800, 85)"
              [alt]="'Botella de ' + (product()?.name || 'Whisky Real Audiencia') + ' - Single Malt de Altura'"
              class="product-featured-img"
              loading="eager"
              fetchpriority="high"
              decoding="async"
              width="600"
              height="750"
              itemprop="image"
              (error)="onImageError($event)"
            >
            <div class="altitude-stamp" title="Destilado y madurado a 2500 metros sobre el nivel del mar en los Andes">
              <span class="stamp-number">2500</span>
              <span class="stamp-label">MSNM</span>
            </div>
          </div>
        </div>

        <!-- COLUMNA DERECHA: INFORMACIÓN Y COMPRA -->
        <div class="product-details-col">
          <span class="product-category-sub" itemprop="category">{{ product()?.type || 'Whisky Andino Single Malt' }}</span>
          <h1 class="product-title" id="product-title-heading">{{ product()?.name }}</h1>

          <!-- BADGE DE CALIFICACIÓN 5 ESTRELLAS DINÁMICA -->
          <div class="product-header-rating">
            <button type="button" (click)="scrollToReviews($event)" class="rating-header-link" title="Ver calificaciones y opiniones de clientes">
              <div class="stars-gold" [attr.aria-label]="'Calificación ' + ratingValue() + ' de 5 estrellas'">
                <span class="star" [class.filled]="ratingValue() >= 1">★</span>
                <span class="star" [class.filled]="ratingValue() >= 2">★</span>
                <span class="star" [class.filled]="ratingValue() >= 3">★</span>
                <span class="star" [class.filled]="ratingValue() >= 4">★</span>
                <span class="star" [class.filled]="ratingValue() >= 4.7">★</span>
              </div>
              <span class="rating-val">{{ ratingValue() | number:'1.1-1' }}</span>
              <span class="rating-link-text">· {{ reviewsCount() }} {{ reviewsCount() === 1 ? 'opinión' : 'opiniones' }} de catadores</span>
            </button>
          </div>

          <div class="price-container">
            @if (product()?.discount_price && product()?.discount_price! > 0) {
              <span class="price-discount">${{ product()?.discount_price | number:'1.2-2' }}</span>
              <span class="price-regular original">${{ product()?.price | number:'1.2-2' }}</span>
            } @else {
              <span class="price-main">${{ product()?.price | number:'1.2-2' }}</span>
            }
            <span class="tax-note">Impuestos incluidos · Envío directo desde destilería</span>
          </div>

          <!-- ESPECIFICACIONES CLAVE DE LA BOTELLA -->
          <div class="specs-grid" role="list">
            <div class="spec-card" role="listitem">
              <span class="spec-title">Graduación</span>
              <span class="spec-value">{{ product()?.abv }}</span>
            </div>
            <div class="spec-card" role="listitem">
              <span class="spec-title">Añejamiento</span>
              <span class="spec-value">{{ product()?.age }}</span>
            </div>
            <div class="spec-card" role="listitem">
              <span class="spec-title">Origen</span>
              <span class="spec-value">Andes, Ecuador</span>
            </div>
            <div class="spec-card" role="listitem">
              <span class="spec-title">Barrica</span>
              <span class="spec-value">Roble Tostado</span>
            </div>
          </div>

          <!-- DESCRIPCIÓN PRINCIPAL PARA AEO -->
          <p class="product-lead-description">
            {{ product()?.long_description }}
          </p>

          <!-- BLOQUE DE ATRIBUTOS Y TRIPLETAS SEMÁNTICAS (ESTILIZADO AL DISEÑO LUXURY) -->
          <div class="semantic-triplets-box" aria-label="Atributos de distinción de Whisky Real Audiencia">
            <div class="triplets-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="header-icon" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
              <span class="triplets-header-title">Atributos de Distinción — Whisky Real Audiencia</span>
            </div>
            <ul class="triplets-list">
              @for (triplet of getSemanticTriplets(); track triplet.predicate) {
                <li class="triplet-item" itemscope itemtype="https://schema.org/PropertyValue">
                  <span class="triplet-subject" itemprop="name">{{ triplet.subject }}</span>
                  <span class="triplet-predicate">{{ triplet.predicate }}</span>
                  <span class="triplet-object" itemprop="value">{{ triplet.object }}</span>
                </li>
              }
            </ul>
          </div>

          <!-- SELECTOR DE CANTIDAD Y BOTÓN DE COMPRA MEJORADO -->
          <div class="purchase-actions">
            <div class="quantity-selector">
              <button class="qty-btn" (click)="decrementQuantity()" aria-label="Disminuir cantidad de botellas">-</button>
              <span class="qty-value" aria-label="Cantidad seleccionada">{{ quantity() }}</span>
              <button class="qty-btn" (click)="incrementQuantity()" aria-label="Aumentar cantidad de botellas">+</button>
            </div>

            <button 
              class="btn-buy-now" 
              (click)="addToCart()"
              [attr.aria-label]="'Añadir ' + quantity() + ' botella(s) de ' + product()?.name + ' al carrito'"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true" class="cart-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
              </svg>
              <span>Añadir al Carrito — ${{ ((product()?.discount_price || product()?.price || 0) * quantity()) | number:'1.2-2' }}</span>
            </button>
          </div>

          <div class="guarantees-row">
            <div class="guarantee-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <span>Single Malt 100% Auténtico</span>
            </div>
            <div class="guarantee-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              <span>Envío Ágil a Nivel Nacional</span>
            </div>
          </div>
        </div>

      </div>
    </section>

    <!-- SECCIÓN INTERACTIVA DE PESTAÑAS DETALLADAS (AEO ENRIQUECIDO) -->
    <section class="details-tabs-section" aria-label="Información detallada del producto">
      <div class="container">
        <h2 class="sr-only">Notas Sensoriales, Proceso y Maridaje de Whisky Real Audiencia</h2>

        <!-- CABECERA DE PESTAÑAS -->
        <div class="tabs-header" role="tablist">
          <button
            class="tab-btn"
            [class.active]="activeTab() === 'notas'"
            (click)="setTab('notas')"
            role="tab"
            [attr.aria-selected]="activeTab() === 'notas'"
          >
            Notas de Cata
          </button>
          <button
            class="tab-btn"
            [class.active]="activeTab() === 'proceso'"
            (click)="setTab('proceso')"
            role="tab"
            [attr.aria-selected]="activeTab() === 'proceso'"
          >
            Malta & Vertiente Andina
          </button>
          <button
            class="tab-btn"
            [class.active]="activeTab() === 'maridaje'"
            (click)="setTab('maridaje')"
            role="tab"
            [attr.aria-selected]="activeTab() === 'maridaje'"
          >
            Maridaje & Coctelería
          </button>
        </div>

        <!-- CONTENIDO DE PESTAÑA: NOTAS DE CATA -->
        @if (activeTab() === 'notas') {
          <div class="tab-pane active-pane" role="tabpanel">
            <div class="tasting-notes-grid">
              <div class="note-card">
                <div class="note-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3>Nariz</h3>
                <p>{{ product()?.tasting_notes?.nose }}</p>
              </div>

              <div class="note-card highlight">
                <div class="note-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
                  </svg>
                </div>
                <h3>Boca</h3>
                <p>{{ product()?.tasting_notes?.palate }}</p>
              </div>

              <div class="note-card">
                <div class="note-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                  </svg>
                </div>
                <h3>Final</h3>
                <p>{{ product()?.tasting_notes?.finish }}</p>
              </div>
            </div>
          </div>
        }

        <!-- CONTENIDO DE PESTAÑA: PROCESO & MALTA ANDINA -->
        @if (activeTab() === 'proceso') {
          <div class="tab-pane active-pane" role="tabpanel">
            <div class="story-grid">
              <div class="story-content">
                <h3>Carácter Nacido en Glaciares y Volcanes</h3>
                <p>
                  El Whisky Real Audiencia fusiona la técnica milenaria de destilación de malta con la majestuosidad de la cordillera de los Andes. Utilizando agua de vertiente andina purificada naturalmente por capas volcánicas a 2500 msnm.
                </p>
                <ul class="story-list">
                  <li><strong>100% Malta Seleccionada:</strong> Cebada malteada y germinada con tostado a fuego lento.</li>
                  <li><strong>Agua de Glaciar:</strong> Agua con minerales puros que potencian la suavidad del destilado.</li>
                  <li><strong>Maduración Andina:</strong> Almacenado en bodegas frías donde la presión de altura suaviza la turba.</li>
                </ul>
              </div>
              <div class="story-highlight-box">
                <div class="quote-mark" aria-hidden="true">“</div>
                <p class="quote-text">
                  Real Audiencia es la unión perfecta entre el carácter fuerte del malta tradicional y la pureza cristalina de la montaña.
                </p>
                <span class="quote-author">Richard Armendariz — Maestro Destilador De Estancos</span>
              </div>
            </div>
          </div>
        }

        <!-- CONTENIDO DE PESTAÑA: MARIDAJE Y COCTELERÍA -->
        @if (activeTab() === 'maridaje') {
          <div class="tab-pane active-pane" role="tabpanel">
            <div class="pairing-grid">
              <div class="pairing-card">
                <span class="pairing-tag">Maridaje Perfecto</span>
                <h3>Quesos Madurados & Jamón Serrano</h3>
                <p>
                  Su perfil maltoso y ligeramente especiado acompaña magníficamente quesos curados de oveja o cabra, almendras tostadas y carnes curadas de baja salinidad.
                </p>
              </div>
              <div class="pairing-card">
                <span class="pairing-tag">Cóctel Signature</span>
                <h3>Real Audiencia Boulevardier</h3>
                <p>
                  45ml Whisky Real Audiencia, 30ml Vermut Rojo Dulce, 30ml Campari. Agitado suavemente sobre hielo y decorado con piel de pomelo o naranja.
                </p>
              </div>
              <div class="pairing-card">
                <span class="pairing-tag">Modo de Servir</span>
                <h3>En Copa Glencairn con Gota de Agua</h3>
                <p>
                  Servir solo a 16-18°C. Agregar 2 gotas de agua mineral pura para liberar la complejidad de notas aromáticas de manzana horneada y humo dulce.
                </p>
              </div>
            </div>
          </div>
        }

      </div>
    </section>
  }

  <!-- SECCIÓN DE CALIFICACIONES Y OPINIONES DE CLIENTES -->
  @if (product()) {
    <app-product-reviews productSlug="whisky-real-audiencia" [productId]="product()?.id" [productName]="product()?.name || 'Whisky Real Audiencia'" />
  }
</main>

<!-- NOTIFICACIÓN TOAST -->
@if (toastMessage()) {
  <div class="toast-notification" role="status" aria-live="polite">
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
    </svg>
    <span>{{ toastMessage() }}</span>
  </div>
}
